<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
export default {
  name: "App",
};
</script>

<style lang="scss">
@import url("https://fonts.googleapis.com/icon?family=Material+Icons");
@import url("https://fonts.googleapis.com/css?family=Cairo");
@import "theme";

body {
  font-family: "Roboto", "Cairo", sans-serif;
}

* {
  outline: none !important;
}

a {
  text-decoration: none !important;
}

.uppercase {
  text-transform: uppercase;
}

// Datatable fix
thead {
  cursor: ns-resize;
}

.dataTables_paginate {
  margin: 45px 0;

  .paginate_button {
    padding: 10px 15px;
    background: #e4e4e4;
    color: #464646;
    border-radius: 3px;
    margin-right: 5px;
    text-transform: uppercase;
    font-size: 12px;
    cursor: pointer;
  }

  .next {
    margin-left: 5px;
  }

  span {
    display: none;
  }
}

.dataTables_info {
  font-size: 12px;
  margin-top: 20px;
  color: #aaa;
}

.dataTables_length {
  display: none;
}

.dataTables_filter input {
  height: 30px !important;
  border-bottom: 1px solid #d0d0d0 !important;
}

.dataTables_wrapper {
  padding-bottom: 40px !important;
}

input:focus:not([readonly]),
.mui-select:focus select,
textarea:focus:not([readonly]) {
  border-bottom: 1px solid $theme-color !important;
  box-shadow: 0 1px 0 0 $theme-color !important;
}

.dropdown-content li:not(.disabled) span {
  color: $theme-color !important;
}

.mui-select:focus label {
  color: rgba(0, 0, 0, 0.54) !important;
}

select,
input {
  height: 45px !important;
}

.input-field .prefix.active {
  color: $theme-color !important;
}

.btn {
  width: 100% !important;
}

.btn,
.btn:hover {
  background-color: $theme-color !important;
}

table {
  .actions a {
    color: #333;

    &:hover {
      color: $theme-color;
      cursor: pointer;
    }
  }
}

.chip i {
  font-size: 15px;
  vertical-align: middle;
}

.file-field .btn {
  width: inherit !important;
}

.bottom-line tr {
  border-bottom: 1px solid #9e9e9e;
}

.btn-flat {
  background-color: #ddd !important;
  display: block !important;
  text-align: center;
}

a.pagination,
a.toolBox {
  cursor: pointer;
  border: solid 1px;
  padding: 3px;
  border-color: gray;
  color: gray;
}

.datable {
  min-height: 200px;
}
</style>



// WEBPACK FOOTER //
// src/App.vue